define("shared/components/shared/social/instagram-upgrade/modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isVisible}}
    <Shared::Modal @close={{this.closeModal}} data-test-id="ig-upgrade-modal" as |modal|>
      <modal.card class="o--modalCard--narrow">
        <modal.card-header class="u--p__b__0">
          <h2 class="o--modalHeader__title u--text--lg u--text--center">
            {{t "credentials.instagram_login_upgrade.modal.title"}}
          </h2>
        </modal.card-header>
        <modal.card-body class="u--p__lg">
          <div class="tIU--modal__imageCluster">
            <span class="tIU--modal__facebookAvatar">
              {{svg-jar "social-facebook" class="o--icon"}}
            </span>
            <img class="tIU--modal__laterIcon" src="/assets/images/img--instagramLoginUpgrade--laterIcon.png" />
            <div class="tIU--modal__profileAvatar--container">
              <img
                alt={{this.socialProfile.nickname}}
                class="tIU--modal__profileAvatar"
                data-test-id="ig-upgrade-profile-avatar"
                src={{or this.socialProfile.avatarUrl "/assets/images/img--userAvatar--placeholder--square.svg"}}
              />
              <span class="o--user__avatarChild--ig" data-test-id="platform-icon">
                {{svg-jar "social-instagram"}}
              </span>
            </div>
          </div>
          <div class="tIU--modal__infoCard">
            {{svg-jar "info" class="o--icon--lg"}}
            <div class="u--p__l__sm u--text--bold">
              <p class="u--m__0">{{t "credentials.instagram_login_upgrade.modal.info_card"}}</p>
              <Shared::Link
                @href="https://help.later.com/hc/articles/1500000110062"
                @text={{t "credentials.instagram_login_upgrade.modal.info_link"}}
              />
            </div>
          </div>
          <div class="u--m__t__md">
            {{#unless (eq this.options.textParagraphA null)}}
              <p>
                {{or this.options.textParagraphA (t "credentials.instagram_login_upgrade.modal.connect_facebook")}}
              </p>
            {{/unless}}
            {{#unless (eq this.options.textParagraphB null)}}
              <p>
                {{or this.options.textParagraphB (t "credentials.instagram_login_upgrade.modal.unlock_access")}}
              </p>
            {{/unless}}
            {{#unless (eq this.options.unlockList null)}}
              <ul class="tIU--modal__unlockList u--text--bold">
                {{#if (eq this.options.unlockList undefined)}}
                  <li>{{t "credentials.instagram_login_upgrade.modal.feature_list.analytics"}}</li>
                  <li>{{t "credentials.instagram_login_upgrade.modal.feature_list.shoppable_tags"}}</li>
                  <li>{{t "credentials.instagram_login_upgrade.modal.feature_list.hashtag_search"}}</li>
                  <li>{{t "credentials.instagram_login_upgrade.modal.feature_list.add_audio"}}</li>
                {{else}}
                  {{#each this.options.unlockList as |item|}}
                    <li>{{item}}</li>
                  {{/each}}
                {{/if}}
              </ul>
            {{/unless}}
          </div>
  
        </modal.card-body>
        <modal.card-footer>
          <Shared::Ui::Button
            @additional="block"
            @promise={{this.authenticateWithFacebookLogin}}
            @runningText={{t "credentials.instagram_login_upgrade.modal.connecting"}}
            @text={{t "credentials.instagram_login_upgrade.modal.button"}}
            @variant="primary"
            data-test-id="authenticate-button"
          />
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  {{/if}}
  
  {{#if (and this.canShowInstagramAuthStatus this.showInstagramAuthStatus)}}
    <Shared::Portal @destinationElement="root-portal">
      {{! @glint-expect-error: Shared::Credentials::InstagramAuthStatus }}
      <Shared::Credentials::InstagramAuthStatus
        @closeModal={{set this "showInstagramAuthStatus" false}}
        @socialProfile={{this.socialProfile}}
        @source={{this.sourcePage}}
      />
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "GxjxFscR",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[1,\"  \"],[8,[39,1],[[24,\"data-test-id\",\"ig-upgrade-modal\"]],[[\"@close\"],[[30,0,[\"closeModal\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card\"]],[[24,0,\"o--modalCard--narrow\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__0\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--text--lg u--text--center\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"credentials.instagram_login_upgrade.modal.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__lg\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"tIU--modal__imageCluster\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"tIU--modal__facebookAvatar\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"social-facebook\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"img\"],[14,0,\"tIU--modal__laterIcon\"],[14,\"src\",\"/assets/images/img--instagramLoginUpgrade--laterIcon.png\"],[12],[13],[1,\"\\n          \"],[10,0],[14,0,\"tIU--modal__profileAvatar--container\"],[12],[1,\"\\n            \"],[10,\"img\"],[15,\"alt\",[30,0,[\"socialProfile\",\"nickname\"]]],[14,0,\"tIU--modal__profileAvatar\"],[14,\"data-test-id\",\"ig-upgrade-profile-avatar\"],[15,\"src\",[28,[37,4],[[30,0,[\"socialProfile\",\"avatarUrl\"]],\"/assets/images/img--userAvatar--placeholder--square.svg\"],null]],[12],[13],[1,\"\\n            \"],[10,1],[14,0,\"o--user__avatarChild--ig\"],[14,\"data-test-id\",\"platform-icon\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"social-instagram\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tIU--modal__infoCard\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"info\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n          \"],[10,0],[14,0,\"u--p__l__sm u--text--bold\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--m__0\"],[12],[1,[28,[35,2],[\"credentials.instagram_login_upgrade.modal.info_card\"],null]],[13],[1,\"\\n            \"],[8,[39,5],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/1500000110062\",[28,[37,2],[\"credentials.instagram_login_upgrade.modal.info_link\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--m__t__md\"],[12],[1,\"\\n\"],[41,[51,[28,[37,7],[[30,0,[\"options\",\"textParagraphA\"]],null],null]],[[[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,4],[[30,0,[\"options\",\"textParagraphA\"]],[28,[37,2],[\"credentials.instagram_login_upgrade.modal.connect_facebook\"],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[41,[51,[28,[37,7],[[30,0,[\"options\",\"textParagraphB\"]],null],null]],[[[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,4],[[30,0,[\"options\",\"textParagraphB\"]],[28,[37,2],[\"credentials.instagram_login_upgrade.modal.unlock_access\"],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[41,[51,[28,[37,7],[[30,0,[\"options\",\"unlockList\"]],null],null]],[[[1,\"            \"],[10,\"ul\"],[14,0,\"tIU--modal__unlockList u--text--bold\"],[12],[1,\"\\n\"],[41,[28,[37,7],[[30,0,[\"options\",\"unlockList\"]],[27]],null],[[[1,\"                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"credentials.instagram_login_upgrade.modal.feature_list.analytics\"],null]],[13],[1,\"\\n                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"credentials.instagram_login_upgrade.modal.feature_list.shoppable_tags\"],null]],[13],[1,\"\\n                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"credentials.instagram_login_upgrade.modal.feature_list.hashtag_search\"],null]],[13],[1,\"\\n                \"],[10,\"li\"],[12],[1,[28,[35,2],[\"credentials.instagram_login_upgrade.modal.feature_list.add_audio\"],null]],[13],[1,\"\\n\"]],[]],[[[42,[28,[37,9],[[28,[37,9],[[30,0,[\"options\",\"unlockList\"]]],null]],null],null,[[[1,\"                  \"],[10,\"li\"],[12],[1,[30,2]],[13],[1,\"\\n\"]],[2]],null]],[]]],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,10],[[24,\"data-test-id\",\"authenticate-button\"]],[[\"@additional\",\"@promise\",\"@runningText\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"authenticateWithFacebookLogin\"]],[28,[37,2],[\"credentials.instagram_login_upgrade.modal.connecting\"],null],[28,[37,2],[\"credentials.instagram_login_upgrade.modal.button\"],null],\"primary\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,11],[[30,0,[\"canShowInstagramAuthStatus\"]],[30,0,[\"showInstagramAuthStatus\"]]],null],[[[1,\"  \"],[8,[39,12],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n\"],[1,\"    \"],[8,[39,13],null,[[\"@closeModal\",\"@socialProfile\",\"@source\"],[[28,[37,14],[[30,0],\"showInstagramAuthStatus\",false],null],[30,0,[\"socialProfile\"]],[30,0,[\"sourcePage\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"modal\",\"item\"],false,[\"if\",\"shared/modal\",\"t\",\"svg-jar\",\"or\",\"shared/link\",\"unless\",\"eq\",\"each\",\"-track-array\",\"shared/ui/button\",\"and\",\"shared/portal\",\"shared/credentials/instagram-auth-status\",\"set\"]]",
    "moduleName": "shared/components/shared/social/instagram-upgrade/modal.hbs",
    "isStrictMode": false
  });
  let InstagramUpgradeModalComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), (_class = class InstagramUpgradeModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);
      _initializerDefineProperty(this, "showInstagramAuthStatus", _descriptor7, this);
      // Tracked property to hold the social profile being connected.
      // When multiple Instagram login profiles exist, this prevents the displayed social profile from switching during refresh
      _initializerDefineProperty(this, "connectingSocialProfile", _descriptor8, this);
      _defineProperty(this, "authenticateWithFacebookLogin", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.socialProfile) {
            this.connectingSocialProfile = this.socialProfile;
            yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
              refreshSocialProfiles: [this.socialProfile]
            });
            if (!this.instagramAuth.hasAllPermissions(this.socialProfile)) {
              this.alerts.alert(this.intl.t('account.controllers.groups.facebook.insufficient_permissions', {
                social_profile: this.socialProfile.nickname
              }));
            }
            if (this.socialProfile.needsRefresh) {
              this.instagramAuth.resetInstagramAuthStatusDates();
              this.showInstagramAuthStatus = true;
            }
          }
          this.closeModal();
        }
      }), null, "authenticateWithFacebookLogin", "drop"));
    }
    get canShowInstagramAuthStatus() {
      return this.instagramAuth.canShowInstagramAuthStatus;
    }
    get isVisible() {
      return this.instagramAuth.isInstagramUpgradeModalVisible;
    }
    get options() {
      return this.instagramAuth.instagramUpgradeModalOptions;
    }
    get socialProfile() {
      let socialProfile = this.connectingSocialProfile ?? this.selectedSocialProfiles.profiles.find(profile => profile.isInstagramLogin) ?? this.auth.currentGroup?.socialProfiles.find(profile => profile.isInstagramLogin);
      if (!socialProfile && this.auth.currentSocialProfile.isInstagramLogin) {
        socialProfile = this.auth.currentSocialProfile;
      }
      return socialProfile;
    }
    get sourcePage() {
      return this.router.currentRouteName?.split('.')[1];
    }
    closeModal() {
      this.instagramAuth.isInstagramUpgradeModalVisible = false;
      this.connectingSocialProfile = undefined;
      this.options.onClose?.();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showInstagramAuthStatus", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "connectingSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InstagramUpgradeModalComponent);
});